import { CreationIcon, DeleteIcon, ModificationIcon } from "../../../assets/icons";

interface Props {
  type: "Creation" | "Modification" | "Delete";
}

const WorkflowType: React.FunctionComponent<Props> = ({ type }) => {
  switch (type) {
    case "Modification": {
      return <ModificationIcon />;
    }
    case "Delete": {
      return <DeleteIcon />;
    }
    default: {
      return <CreationIcon />;
    }
  }
};

export default WorkflowType;
